import React, { useMemo } from 'react'

import View from '../../../../components/pdf/View'
import Text from '../../../../components/pdf/Text'
import Separator from '../../../../components/pdf/Separator'
import { Table, TableCol, TableRow } from '../../../../components/pdf/Table'
import { TableColText, TableHeadText } from '../../../../components/pdf/TableHelpers'
import {
  findReplyByQuestionId,
  getReplyValue,
  toDateFormat,
  filterRepliesByQuestionType,
  toPtNumber,
  findReplyByQuestionName
} from '../_helpers/pdfHelpers'
import { useServiceOrder } from '../_load/ServiceOrderLoader'
import Image from '../../../../components/pdf/Image'

const cleanText = text => text?.trim()?.replace(/[\t\n\\"]/g, '')

const questionWeights = {
  'A obra está acompanhando as documentações iniciais através do F-OBR-01 TAP Termo de Abertura do Projeto? As documentações se encontram completas e disponiveis na pasta fisica e na rede da obra para acesso de todos?': 2,
  'O layout do canteiro foi planejado e está atualizado?': 1,
  'A obra solicitou a placa de obra ao departamento de marketing ?': 1,
  'A equipe de obra avaliou os riscos, orientando eventuais ajustes de projetos, bem como medidas preventivas de segurança contra quedas de materiais e ruídos? Foi registrado no F-OBR-00 Tratativas para Aprendizados, Riscos e Melhorias?': 1,
  'Está disponível no tapume da obras os canais de comunicação entre comunidade e Grupo Kallas conforme modelo padrão M-OBR-25/ M-OBR-26?': 2,
  'Houve necessidade de reparos na vizinhança? Se sim, foram evidenciados no F-OBR-02 Termo de transação e F-OBR-03 Termo de Quitação?': 2,
  'No inicio da obra foi realizada pelo engenheiro a F-OBR-22 Análise Comparativa entre Projetos? As ocorrências foram registradas no Construflow?': 1,
  'Foi solicitada/realizada apresentação dos projetos executivos? Estavam presentes Gerente de Obras, Coordenador de Projetos, Engenheiro da Obra, Mestre de Obras (se possível) e os Projetistas?': 1,
  'A obra está realizando a análise critica dos projetos e registrando os problemas encontrados e ações no Construflow?': 2,
  'Os projetos de produção (escoramento, forma, grua, mini grua e etc.) estão cadastrados na plataforma de gerenciamento de projetos ?': 1,
  'Os projetos estão disponíveis para consulta no canteiro de obras através das etiquetas/placas com QR Code?': 1,
  'O controle de distribuição de projetos físico na obra está sendo realizado através do Construcode ou F-OBR-34 Controle de Distribuição de Projetos ?': 2,
  'Os projetos físicos no canteiro estão na ultima versão e evidenciados com carimbo de acordo com o responsável pelo uso Engenharia, Mestre, Campo?': 2,
  'Em obras com parede diafragma, foi realizado a setorização dos pavimentos garagens através do Laser Scan com a finalidade de analisar o projetado x executado e entregue relatório para a obra?': 1,
  'As validações da unidade modelo, de instalações elétricas e hidráulicas e Acabamentos foram realizadas conforme previsto no P-OBR-01?': 1,
  'Foi elaborado o F-OBR-11 Plano de Qualidade de Obra conforme escopo previsto no P-OBR-01? O mesmo se encontra atualizado e divulgado na engenharia?': 2,
  'A equipe da obra foi treinada conforme matriz de treinamento prevista no F-OBR-11 Plano de Qualidade de Obra?': 2,
  'O diário de obras está sendo preenchido conforme I-OBR-09?': 2,
  'A obra planejou e está registrando a realização dos ensaios dentro do F-OBR-57 - Plano de Controle Tecnológico?': 3,
  'A Politica da Qualidade está divulgada através de placas fixadas no canteiro da obra (Areas técnicas, áreas comuns e nos pavimentos)?': 2,
  'Os equipamentos calibrados estão sendo controlados conforme I-OBR-05 e  registrados no F-OBR-14 Controle de Equipamentos Calibrados?': 1,
  'Foi realizado a aferição dos equipamentos distribuídos em campo conforme I-OBR-05 e registrados no F-OBR-15 Controle de Equipamentos de Verificação em Campo?': 1,
  'A entrada e devolução de ecoramento está sendo acompanhada e registrada no F-OBR-41 Controle de Escoramento?': 1,
  'Os materiais são recebidos de acordo com as especificações do pedido ou contrato e evidenciados através do carimbo de recebimento?': 2,
  'Todos os materiais estão armazenados conforme I-OBR-02 Tabela de Inspeção e Armazenamento de Materiais?': 3,
  'Na entrega das cerâmicas, a obra está registrando e separando a reserva técnica conforme especificado no F-OBR-18 Reserva Técnica?': 2,
  'No caso de obra com Incorporadores, está sendo realizada a Pesquisa de Satisfação conforme F-OBR-23 conforme cronograma?': 1,
  'A produção de argamassa, chapisco para revestimento interno e externo ou graute está seguindo o especificado nos PES 13, 14 e 15?': 2,
  'O controle da Alvenaria Estrutural está sendo realizado e evidenciado conforme F-OBR-28 Plano de Controle de Qualidade e Alvenaria Estrutural? Todas as documentações necessárias estão retidas e rastreaveis? Os grautes estão sendo registrados no F-OBR-61 Controle de Graute e o mesmo se encontra atualizado?': 3,
  'O controle de concreto está sendo realizado e evidenciado conforme I-OBR-07? Todas as documentações necessárias estão retidas e rastreaveis?': 3,
  'As concretagens estão registradas no F-OBR-45 Controle de Concretagem? A mesma se encontra atualizada?': 2,
  'Os serviços estão executados conforme projetos, memoriais PES ou outros?': 3,
  'Os serviços estão sendo inspecionados nas FVS especificas? A conferencia se encontra atualizada conforme os serviços?': 3,
  'Os serviços estão preservados conforme I-OBR-03 Preservação dos serviços acabados?': 3,
  'O F-OBR-00 Tratativas para Aprendizados, Riscos e Melhorias está sendo acompanhado pela equipe da obra?': 1,
  'Os Formulários, Instruções e Processos estão sendo utilizados conforme as revisões vigentes?': 2,
  'Existem alterações de projetos e custo? Está acompanhando a aprovação através do documento M-ORC-15- ASA?': 1,
  'A obra definiu as metas de produção semanalmente, utilizando F-GQP-04 Ata de reunião? (PPC)': 1,
  'Foi enviado junto ao cronograma físico o F-PLA-03 Controle de estoque , F-PLA-05 Controle de serviços executados e não pagos e o F-PLA-05 Previsão de desembolso?': 1,
  "Foram providenciadas ART's de execução conforme P-OBR-01?": 2
}

const replyIdsByCategory = {
  'Pré obra': [1, 2, 3],
  'Vizinhos e transeuntes': [4, 5, 6],
  Projetos: [7, 8, 9, 10, 11, 12, 13, 14, 15],
  Qualidade: [16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37],
  Orçamento: [38],
  Planejamento: [39, 40],
  Suprimentos: [41]
}

const RequirementReplies = ({ replyIds, totalPesos }) => {
  const { replies } = useServiceOrder()

  const formatNumber = value => {
    const tmpValue = value.toFixed(2)

    return Number(tmpValue)
  }

  const validReplies = replyIds.filter(replyId => {
    const reply = findReplyByQuestionId(replies, replyId)
    if (!reply || !reply.value) return false
    const replyValue = getReplyValue(reply).trim()
    return replyValue !== 'N/A'
  })

  return (
    <>
      {validReplies.map(replyId => {
        const reply = findReplyByQuestionId(replies, replyId)
        const replyValue = getReplyValue(reply).trim()
        const absoluteValue = Number(replyValue?.split('=')?.[0])
        let value
        let peso = 0
        let finalPercent = 0
        let finalWeight = 0
        if (typeof absoluteValue === 'number') {
          let questionName = cleanText(reply?.question?.name)
          peso = questionWeights[questionName]
          value = absoluteValue
          finalWeight = (peso * (peso / totalPesos) * 100) / 100

          if (absoluteValue > 2) {
            finalPercent = 100
          } else if (absoluteValue === 2) {
            finalPercent = 50
          }
        } else {
          value = 'ÑAPLICA'
        }
        return (
          <TableRow key={replyId}>
            <TableCol>{reply?.question?.name}</TableCol>
            <TableCol style={{ verticalAlign: 'middle' }} align="center">
              <Text bold align={'center'}>
                {value}
              </Text>
            </TableCol>
          </TableRow>
        )
      })}
    </>
  )
}

const Requirement = ({ categoryName, replyIds, totalPesos }) => {
  const { replies } = useServiceOrder()

  const hasValidReplies = replyIds.some(replyId => {
    const reply = findReplyByQuestionId(replies, replyId)
    if (!reply || !reply.value) return false
    const replyValue = getReplyValue(reply).trim()
    return replyValue !== 'N/A'
  })

  if (!hasValidReplies) {
    return null
  }

  return (
    <>
      <TableRow>
        <TableColText colSpan={5} bold bgColor={'#BFBFBF'} align="center">
          {categoryName}
        </TableColText>
      </TableRow>
      <RequirementReplies replyIds={replyIds} totalPesos={totalPesos} />
    </>
  )
}

const Notas = ({ replies }) => {
  return (
    <Table width="100%">
      <TableRow>
        <TableHeadText width={'70%'} align="center" bold={false}>
          Apontamentos para notas 1 e 2
        </TableHeadText>
        <TableHeadText align="center" bold={false}>
          Graduação
        </TableHeadText>
        <TableHeadText align="center" bold={false}>
          Causas (aplicável apenas para não conformidades)
        </TableHeadText>
      </TableRow>
      {Object.keys(questionWeights).map((question, index) => {
        const reply = replies.find(reply => cleanText(reply?.question?.name) === cleanText(question))

        if (reply?.value?.name?.startsWith('1') || reply?.value?.name?.startsWith('2')) {
          const childrenReplies = replies.filter(r => r?.question?.parentReference === reply?.question?.reference)
          const requisito = findReplyByQuestionName(childrenReplies, 'Requisito')
          const fato = findReplyByQuestionName(childrenReplies, 'Fato')
          const evidencia = findReplyByQuestionName(childrenReplies, 'Evidência')

          return (
            <TableRow key={index}>
              <TableColText width={'70%'}>
                <b>Requisito: </b>
                {requisito?.value}
                <br />
                <b>Fato: </b>
                {fato?.value}
                <br />
                <b>Evidência: </b>
                {evidencia?.value}
              </TableColText>
            </TableRow>
          )
        } else {
          return <></>
        }
      })}
    </Table>
  )
}

const Fotos = ({ replies }) => {
  const images412 = findReplyByQuestionId(replies, 412)
  const otherImages = filterRepliesByQuestionType(replies, 'gallery')
    .map(reply => reply?.value)
    .flat()

  const allImages = [].concat(images412?.value?.length ? images412?.value : []).concat(otherImages)

  if (!allImages?.length) return <></>
  return (
    <>
      <Separator weight={4} />
      <Table width="100%" style={{ pageBreakInside: 'auto', pageBreakAfter: 'auto' }}>
        <TableRow>
          <TableColText bold align="center">
            {'Fotos'}
          </TableColText>
        </TableRow>
        {allImages.map(image => {
          return (
            <TableRow key={image?.id} style={{ paddingTop: '10px', pageBreakInside: 'auto', pageBreakAfter: 'auto' }}>
              <TableCol style={{ padding: '5px' }}>
                <Image src={image?.src} maxWidth={280} ignoreFixedSize />
              </TableCol>
            </TableRow>
          )
        })}
      </Table>
    </>
  )
}

const Content = () => {
  const { replies, place, endDate, user } = useServiceOrder()
  const date = toDateFormat(endDate, 'DD/MM/YYYY')

  const auditedTeam = getReplyValue(findReplyByQuestionId(replies, 7108))

  const totalPesos = useMemo(() => {
    let total = 0
    Object.keys(questionWeights).forEach(question => {
      const reply = replies.find(reply => reply?.question?.name?.trim() === question?.trim())

      if (!reply || !reply.value) {
        return
      }

      const replyValue = getReplyValue(reply).trim()

      if (replyValue === 'N/A') {
        return
      }

      const absoluteValue = Number(replyValue.split('=')[0])
      let peso = 0
      if (typeof absoluteValue === 'number') {
        peso = questionWeights[question]
      }
      total = total + peso
    })
    return total
  }, [replies])

  const data = useMemo(() => {
    let dados = {}
    Object.keys(questionWeights).forEach(question => {
      const reply = replies.find(reply => cleanText(reply?.question?.name) === cleanText(question))

      if (!reply || !reply.value) {
        return
      }

      const replyValue = getReplyValue(reply).trim()

      if (replyValue === 'N/A') {
        return
      }

      const replyNumber = Number(replyValue.split('=')[0])
      let value
      let peso = 0
      let finalPercent = 0
      let finalWeight = 0
      if (typeof replyNumber === 'number') {
        let questionName = cleanText(reply?.question?.name)
        peso = questionWeights[questionName]
        value = replyNumber
        finalWeight = (peso * (peso / totalPesos) * 100) / 100

        if (replyNumber > 2) {
          finalPercent = 100
        } else if (replyNumber === 2) {
          finalPercent = 50
        }
      } else {
        value = 'ÑAPLICA'
      }

      dados[question] = {
        reply: value,
        weight: finalWeight,
        percent: finalWeight * finalPercent
      }
    })
    return dados
  }, [replies, totalPesos])

  const resumo = useMemo(() => {
    let totalPeso = 0
    let percentFinal = 0

    Object.keys(data).forEach(question => {
      let { weight, percent } = data[question]
      weight = weight ? Number(weight) : 0
      percent = percent ? Math.round(Number(percent) * 100) / 100 : 0
      totalPeso += weight
      percentFinal += percent
    })

    return { totalPeso, percentFinal }
  }, [data])

  return (
    <>
      <View pageBreakAfter>
        <Text size={'small'}>
          <Table width="100%">
            <tr style={{ border: '1px solid black' }}>
              <td style={{ width: '141px' }}>
                <Text align={'center'} bold>
                  Objetivo e escopo:
                </Text>
              </td>
              <td>
                <Text>
                  Avaliar a aderência aos procedimentos aplicáveis à área e ao processo com base na ISO 9001:2015, SiAC:
                  2021 - Nível A
                </Text>
              </td>
            </tr>
            <tr style={{ border: '1px solid black' }}>
              <td style={{ width: '141px' }}>
                <Text align={'center'} bold>
                  Obra:
                </Text>
              </td>
              <td>
                <Text>{place.name}</Text>
              </td>
            </tr>
            <tr style={{ border: '1px solid black' }}>
              <td style={{ width: '141px' }}>
                <Text align={'center'} bold>
                  Data:
                </Text>
              </td>
              <td>
                <Text>{date}</Text>
              </td>
            </tr>
            <tr style={{ border: '1px solid black' }}>
              <td style={{ width: '141px' }}>
                <Text align={'center'} bold>
                  Auditor(es):
                </Text>
              </td>
              <td>
                <Text>{user.name}</Text>
              </td>
            </tr>
            <tr style={{ border: '1px solid black' }}>
              <td style={{ width: '141px' }}>
                <Text align={'center'} bold>
                  Equipe auditada:
                </Text>
              </td>
              <td>
                <Text>{auditedTeam}</Text>
              </td>
            </tr>
          </Table>
          <Separator weight={4} />
          <Table width="30%">
            <TableRow>
              <TableColText bold align="center">
                {'ADERÊNCIA'}
              </TableColText>
            </TableRow>
            <TableRow>
              <TableCol style={{ padding: '5px' }}>{'1 = Não cumpre o requisito'}</TableCol>
            </TableRow>
            <TableRow>
              <TableCol style={{ padding: '5px' }}>{'2 = Cumpre parcialmente o requisito'}</TableCol>
            </TableRow>
            <TableRow>
              <TableCol style={{ padding: '5px' }}>{'3 = Cumpre o requisito'}</TableCol>
            </TableRow>
          </Table>
          <Separator weight={4} />
          <Table width="100%" style={{ pageBreakInside: 'auto', pageBreakAfter: 'auto' }}>
            <TableRow>
              <TableHeadText width={'85%'} bgColor={'#558ed5'} align="center" color={'white'} bold={false}>
                PROCEDIMENTO DE OBRAS - P-OBR-01
              </TableHeadText>
              <TableHeadText bgColor={'#558ed5'} align="center" color={'white'} bold={false}>
                %Final
              </TableHeadText>
            </TableRow>
            <TableRow>
              <TableColText bold align="left">
                {'OBRAS'}
              </TableColText>
              <TableColText bold align="center">
                {toPtNumber(parseFloat((resumo.percentFinal / resumo.totalPeso).toFixed(2)))}%
              </TableColText>
            </TableRow>
            <Requirement categoryName={'Pré obra'} replyIds={replyIdsByCategory['Pré obra']} totalPesos={totalPesos} />
            <Requirement
              categoryName={'Vizinhos e transeuntes'}
              replyIds={replyIdsByCategory['Vizinhos e transeuntes']}
              totalPesos={totalPesos}
            />
            <Requirement categoryName={'Projetos'} replyIds={replyIdsByCategory['Projetos']} totalPesos={totalPesos} />
            <Requirement
              categoryName={'Qualidade'}
              replyIds={replyIdsByCategory['Qualidade']}
              totalPesos={totalPesos}
            />
            <Requirement
              categoryName={'Orçamento'}
              replyIds={replyIdsByCategory['Orçamento']}
              totalPesos={totalPesos}
            />
            <Requirement
              categoryName={'Planejamento'}
              replyIds={replyIdsByCategory['Planejamento']}
              totalPesos={totalPesos}
            />
            <Requirement
              categoryName={'Suprimentos'}
              replyIds={replyIdsByCategory['Suprimentos']}
              totalPesos={totalPesos}
            />
            <TableRow>
              <TableColText bold align="right">
                {'NOTA PAP'}
              </TableColText>
              <TableColText bold colSpan={3} align="center">
                {isNaN(parseFloat((resumo.percentFinal / resumo.totalPeso).toFixed(2)))
                  ? 0
                  : parseFloat((resumo.percentFinal / resumo.totalPeso).toFixed(2))}
                %
              </TableColText>
            </TableRow>
          </Table>
          <Separator weight={4} />
          <Notas replies={replies} />
        </Text>
      </View>
      <Separator weight={4} />
      <View pageBreakAfter>
        <Fotos replies={replies} />
      </View>
    </>
  )
}

export default Content
